import { PrivacyAgreementContent } from "@/pages/welcome-screen/privacy-content";
import { TermsAndConditionsContent } from "@/pages/welcome-screen/terms-content";
import { cn } from "@/utils/cn";
import { IonModal } from "@ionic/react";
import { memo } from "react";

interface LegalLinksFooterProps {
  className?: string;
  linkClassName?: string;
  idPrefix?: string;
}

export const LegalLinksFooter = memo(function LegalLinksFooter({
  className,
  linkClassName,
  idPrefix = "paywall",
}: LegalLinksFooterProps) {
  const termsTriggerId = `${idPrefix}-open-modal-term`;
  const privacyTriggerId = `${idPrefix}-open-modal-policy`;
  const linkClass = cn(
    "cursor-pointer p-0 text-[13px] leading-normal font-medium underline",
    linkClassName,
  );

  return (
    <>
      <div className={cn("flex items-center justify-center gap-4 pt-2 text-center", className)}>
        <span id={privacyTriggerId} className={linkClass}>
          Privacy Policy
        </span>
        <span aria-hidden="true">·</span>
        <span id={termsTriggerId} className={linkClass}>
          Terms of Use
        </span>
      </div>

      <IonModal
        trigger={privacyTriggerId}
        initialBreakpoint={0.8}
        breakpoints={[0, 0.8, 1]}
        handleBehavior="cycle"
        style={{
          "--border-radius": "56px",
        }}
      >
        <div className="mt-8 overflow-y-auto p-8">
          <PrivacyAgreementContent />
        </div>
      </IonModal>

      <IonModal
        trigger={termsTriggerId}
        initialBreakpoint={0.8}
        breakpoints={[0, 0.8, 1]}
        handleBehavior="cycle"
        style={{
          "--border-radius": "56px",
        }}
      >
        <div className="mt-8 overflow-y-auto p-8">
          <TermsAndConditionsContent />
        </div>
      </IonModal>
    </>
  );
});
